import { useState } from 'react';

import { __Front as __ } from '@Shared/lib';

import { cn } from '@Blocks/_components/ui/utils';

import type { SearchClass } from '@/_types/Search/Search';

import { CloseIcon, LoupeIcon } from '../../Icons';

export default function Search({
	homeUrl,
	itemClass,
}: {
	homeUrl: string;
	itemClass: SearchClass;
}) {
	const [openSearch, setOpenSearch] = useState<boolean>(false);

	const ToogleSearch = () => {
		if (openSearch) {
			setOpenSearch(false);
		} else {
			setOpenSearch(true);
		}
	};

	let classForm = 'invisible pointer-events-none translate-y-0 opacity-0';
	const invisible = 'opacity-0 pointer-events-none';
	const visible = 'opacity-1 pointer-events-auto';

	if (openSearch) {
		classForm = 'visible pointer-events-auto translate-y-8 opacity-1';
	}

	return (
		<div className='group relative flex py-5'>
			<button title={__('Open search')} className='group relative' onClick={ToogleSearch}>
				<div className={cn('transition-all', openSearch ? invisible : visible)}>
					<LoupeIcon className={cn('inline-bloc ', itemClass?.iconColor)} />
				</div>
				<div
					className={cn(
						'transition-all absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ',
						openSearch ? visible : invisible
					)}
				>
					<CloseIcon className={cn('inline-bloc ', itemClass?.iconColor)} />
				</div>
			</button>
			<div
				className={cn(
					'transition-all absolute right-0 top-full z-[999] shadow-lg min-w-80 target:min-w-fit',
					classForm,
					itemClass.searchRadius
				)}
			>
				<form
					role='search'
					action={homeUrl}
					method='get'
					className={cn('w-full relative', itemClass?.search)}
				>
					<label className='invisible absolute size-0 opacity-0' htmlFor='search'>
						{__('Search')}
					</label>
					<input
						id='search'
						type='text'
						name='s'
						placeholder={__('Search')}
						className={cn('w-full p-5 rounded-minos-header-mainnav-search-radius', itemClass?.searchBg)}
					/>
					<button title={__('Research')} className='absolute right-5 top-1/2 -translate-y-1/2'>
						<LoupeIcon className={cn('inline-bloc ', itemClass.iconColor)} />
					</button>
				</form>
			</div>
		</div>
	);
}
